module.exports = __webpack_public_path__ + "static/media/dublin-town.cf507e90.png";